"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorExtractLinksPredicates = void 0;
const bus_extract_links_1 = require("@comunica/bus-extract-links");
const core_1 = require("@comunica/core");
/**
 * A comunica Traverse Predicates RDF Metadata Extract Actor.
 */
class ActorExtractLinksPredicates extends bus_extract_links_1.ActorExtractLinks {
    constructor(args) {
        super(args);
        this.stringPredicates = args.predicateRegexes;
        this.predicates = args.predicateRegexes.map(stringRegex => new RegExp(stringRegex, 'u'));
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        return {
            links: await bus_extract_links_1.ActorExtractLinks.collectStream(action.metadata, (quad, links) => {
                if (!this.checkSubject || this.subjectMatches(quad.subject.value, action.url)) {
                    for (const regex of this.predicates) {
                        if (regex.test(quad.predicate.value)) {
                            links.push({
                                url: quad.object.value,
                                metadata: {
                                    producedByActor: {
                                        name: this.name,
                                        predicates: this.stringPredicates,
                                        matchingPredicate: quad.predicate.value,
                                        checkSubject: this.checkSubject,
                                    },
                                },
                            });
                            break;
                        }
                    }
                }
            }),
        };
    }
    subjectMatches(subject, url) {
        const fragmentPos = subject.indexOf('#');
        if (fragmentPos >= 0) {
            subject = subject.slice(0, fragmentPos);
        }
        return subject === url;
    }
}
exports.ActorExtractLinksPredicates = ActorExtractLinksPredicates;
//# sourceMappingURL=ActorExtractLinksPredicates.js.map